import React from 'react'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import { useDispatch } from 'react-redux'
import { groupHomeActions } from 'srcReact/GroupHomePage/actions'

function Invitation({ groupId, invitation, isPrivateGroup, isAutoApproveToJoin, isInPendingState }) {
  const { user_data_who_invites } = invitation
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleDecline = () => {
    dispatch(groupHomeActions.declineInvitation(groupId))
  }
  const handleAccept = () => {
    dispatch(groupHomeActions.acceptInvitation(groupId))
  }
  return (
    <div className={styles.invitationWrapper}>
      <Avatar
        imgWrapperSize='medium'
        userId={user_data_who_invites.id_user}
        profilePicture={user_data_who_invites.profile_picture}
        firstname={user_data_who_invites.firstname}
        lastname={user_data_who_invites.lastname}
        mimeType={user_data_who_invites.mime_type}
        originalTag={user_data_who_invites.original_tag}
        isOriginal={user_data_who_invites.is_original}
        withExpertiseGroup={user_data_who_invites.with_expertise_group}
      />
      <h2 className={styles.title}>
        {t('groupHome.invitation', {
          userName: `${user_data_who_invites.firstname} ${user_data_who_invites.lastname}`,
          type: isPrivateGroup ? ` ${t('groupHome.header.private').toLowerCase()}` : ''
        })}
      </h2>
      {invitation.message && (
        <div className={styles.messageWrapper}>
          <p className={styles.message}>{invitation.message}</p>
        </div>
      )}
      <div className={styles.buttons}>
        <Button style='secondary' text={t('global.decline')} handleClick={handleDecline} />
        <Button
          customStyle={isInPendingState ? styles.nonClickable : ''}
          style={isInPendingState ? 'orange' : 'primary'}
          text={
            isInPendingState
              ? t('groupHome.header.pendingRequest')
              : isAutoApproveToJoin === 0 && invitation.invited_by !== 'staffMember'
              ? t('discover.mygroups.askToJoin')
              : t('global.acceptInvitation')
          }
          handleClick={isInPendingState ? null : handleAccept}
        />
      </div>
    </div>
  )
}

export default Invitation
